export const EVENTS = {
  MAP: {
    LOCATION_SELECTION_REQUIRED: 'map_location_selection_required',
    LOCATION_SELECTED: 'map_location_selected',
  },
  TOAST_NOTIFICATION: {
    SHOW: 'toast.show'
  },
  LOADING: {
    START: 'loading.start',
    FINISH: 'loading.finish'
  }
};

export const GOOGLE_MAP = {
  GOOGLE_MAP_API_KEY: 'AIzaSyAJKEbR8rBb0h4FZYo8GePSjbI9JmbWsmY',
};

export default { EVENTS, GOOGLE_MAP };
